import React from 'react';
import { Box } from '@mui/material';

export default function ({ key, source, errorSource }: { key: string; source: string; errorSource: string }) {
  const [hasImageLoadError, setHasImageLoadError] = React.useState(false);

  return (
    <Box
      component="img"
      onError={
        hasImageLoadError
          ? undefined
          : ({ currentTarget }) => {
              currentTarget.src = errorSource;
              setHasImageLoadError(true);
            }
      }
      src={source}
      alt={`Event image ${key}`}
      loading="eager"
      sx={{ width: '100%', height: 140, objectFit: 'contain' }}
    />
  );
}
